import React, { useState } from 'react';
import { TextField, IconButton, FormHelperText } from '@mui/material';
import { RemoveCircleOutline } from '@mui/icons-material';
import MultiSelectOptionField from './MultiSelectOptionField';

interface MultiSelectOptionEditProps {
    value: string;
    index: number;
    onChange: (index: number, value: string) => void;
    onDelete: (index: number) => void;
    error?: string;
}

/**
 * Multi-select option field.
 */
const MultiSelectOptionEdit: React.FC<MultiSelectOptionEditProps> = ({ value, index, onChange, onDelete, error }) => {
    const [optionValue, setOptionValue] = useState(value);
    const hasError = !!error;

    const handleChange = (newValue: string) => {
        setOptionValue(newValue);
        onChange(index, newValue);
    };

    return (
        <>
            <MultiSelectOptionField>
                <TextField
                    fullWidth
                    size="small"
                    value={optionValue}
                    onChange={(e) => handleChange(e.target.value)}
                    placeholder={`Option ${index + 1}`}
                    sx={{ width: '100%' }}
                    error={hasError}
                />
                <IconButton size="small" onClick={() => onDelete(index)} sx={{ mt: 0.5, ml: 0.5 }}>
                    <RemoveCircleOutline fontSize="small" color="primary" />
                </IconButton>
            </MultiSelectOptionField>
            {hasError && (
                <FormHelperText error sx={{ alignSelf: 'flex-start', ml: 0, mt: 0, mb: 0.5 }}>
                    {error}
                </FormHelperText>
            )}
        </>
    );
};

export default MultiSelectOptionEdit;
